<page-title-content [title]="title" [titleItems]="titleItems | async"></page-title-content>
